module.exports = __webpack_public_path__ + "images/navigation/juul-nora-wide-4fe6cf8f.jpg";